import { HTMLAttributes, useEffect, useMemo } from 'react'

import { sectionsMap } from '@/components/sections'
import { useLoaderStore } from '@/store/loader'

import { WPPageData } from '@/types'

export type BuilderProps = HTMLAttributes<HTMLElement> & {
  pageProps?: WPPageData
}

const Builder = ({ pageProps }: BuilderProps) => {
  const builder = useMemo(() => pageProps?.acf?.builder || [], [pageProps])
  const setLoaderState = useLoaderStore((state) => state.setLoaderState)

  useEffect(() => {
    setLoaderState({ heroCanPlay: true })
    setLoaderState({ isPosterReady: true })
  }, [setLoaderState])

  return (
    <>
      {builder.map(({ acf_fc_layout, ...section }, index) => {
        const Section = sectionsMap[acf_fc_layout]

        return (
          <Section
            key={`section-${index}`}
            className="relative"
            data-component={acf_fc_layout}
            {...section}
          />
        )
      })}
    </>
  )
}

export default Builder
